import { Button, ListItem, Text, Tooltip } from "@rneui/themed";
import React, { useState } from "react";
import { ActivityIndicator, View } from "react-native";
import { FileType, PlaybackEvent, PlaybackEventEmitter, PlaybackState, useContentPlaybackState, usePlaybackStateStore, } from "@annunciate/core";
import { useBookmarkDeleteMutation } from "@annunciate/query";
import { FAIcon, getBookmarkInfo, playerRef, useTheme } from "../..";
const BookmarkListItem = ({ item, content, onEdit, onFinish, }) => {
    const { mutate: deleteMutate } = useBookmarkDeleteMutation();
    const { state } = useContentPlaybackState(item.contentId);
    const isLoading = state === PlaybackState.LOADING;
    const createdAt = new Date(item.createdAt);
    const { title, progress } = getBookmarkInfo(item, content);
    const { colors } = useTheme();
    const [tooltipOpen, setTooltipOpen] = useState(false);
    return (React.createElement(ListItem.Swipeable, { rightContent: (reset) => (React.createElement(Button, { title: "Delete", icon: { name: "delete", color: colors.textPrimary }, buttonStyle: {
                minHeight: "100%",
                backgroundColor: "red",
                borderRadius: 0,
            }, titleStyle: {
                color: colors.textPrimary,
            }, onPress: () => {
                if (!item.position)
                    return;
                deleteMutate({
                    item: { id: item.id },
                });
                reset();
            } })), containerStyle: { borderBottomColor: "grey", borderBottomWidth: 1 } },
        React.createElement(ListItem.Content, { style: { gap: 10 } },
            React.createElement(View, { style: {
                    flexDirection: "row",
                    justifyContent: "space-between",
                    width: "100%",
                    gap: 10,
                } },
                React.createElement(Text, { bold: false }, createdAt.toLocaleString("en-US", {
                    dateStyle: "short",
                    timeStyle: "short",
                })),
                React.createElement(Text, { bold: false, style: { flex: 1 }, numberOfLines: 1 }, title),
                React.createElement(Text, { bold: false }, progress)),
            React.createElement(Text, { numberOfLines: 2 }, item.note),
            React.createElement(View, { style: {
                    flexDirection: "row",
                    justifyContent: "space-between",
                    width: "100%",
                    gap: 10,
                } },
                React.createElement(Button, { type: "clear", title: "Go to Bookmark", titleStyle: { color: "black", flex: 1 }, onPress: async () => {
                        if (isLoading)
                            return;
                        if (!item.position)
                            return;
                        if (usePlaybackStateStore.getState().content?.id === content.id) {
                            await PlaybackEventEmitter.emit(PlaybackEvent.SCRUB, {
                                content: content,
                                to: item.position,
                            });
                            if (content.asset?.type === FileType.EBOOK) {
                                playerRef.current?.expand();
                            }
                        }
                        else {
                            PlaybackEventEmitter.emit(PlaybackEvent.START, {
                                content: content,
                                initialPosition: item.position,
                            });
                        }
                        onFinish && onFinish();
                    } },
                    isLoading ? (React.createElement(ActivityIndicator, { size: 28 })) : (React.createElement(FAIcon, { size: 28, name: "arrow-circle-right" })),
                    React.createElement(Text, { style: { marginLeft: 8 } }, "Go to Bookmark")),
                React.createElement(View, { style: {
                        flexDirection: "row",
                    } },
                    React.createElement(Tooltip, { height: 100, width: 200, visible: tooltipOpen, onOpen: () => setTooltipOpen(true), onClose: () => setTooltipOpen(false), containerStyle: { alignItems: "flex-start", padding: 0 }, popover: React.createElement(React.Fragment, null,
                            React.createElement(Button, { isLeftAligned: true, type: "clear", title: `${item.note ? "Edit" : "Add"} Note`, titleStyle: { color: "white" }, icon: { name: "edit", color: "white" }, onPress: () => onEdit(item), containerStyle: {
                                    width: "100%",
                                    alignItems: "flex-start",
                                    borderBottomWidth: 1,
                                    borderBottomColor: "grey",
                                }, buttonStyle: {
                                    width: "100%",
                                    justifyContent: "flex-start",
                                    paddingLeft: 24,
                                } }),
                            React.createElement(Button, { isLeftAligned: true, type: "clear", title: "Delete", titleStyle: { color: "white" }, icon: { name: "delete", color: "white" }, onPress: () => {
                                    if (!item.position)
                                        return;
                                    deleteMutate({
                                        item: { id: item.id },
                                    });
                                }, containerStyle: {
                                    width: "100%",
                                }, buttonStyle: {
                                    width: "100%",
                                    justifyContent: "flex-start",
                                    paddingLeft: 24,
                                } })), withPointer: false },
                        React.createElement(FAIcon, { size: 28, name: "ellipsis-v", style: { padding: 10 } })))))));
};
export default BookmarkListItem;
//# sourceMappingURL=BookmarkListItem.js.map